import type { ColorAnalysisOptions } from '../utils/color-analyzer';
import { ColorAnalyzer } from '../utils/color-analyzer';

export function useColorAnalyzer(
  base64: string | undefined,
  options?: ColorAnalysisOptions
) {
  const [bgColor, setBgColor] = useState('');
  const handleBase64Analysis = useCallback(async () => {
    if (!base64) {
      return;
    }
    const analyzer = new ColorAnalyzer();
    try {
      const bgColor = await analyzer.fromBase64(base64, options);
      setBgColor(bgColor as string);
    } catch (error) {
      console.error(error);
    }
  }, [base64, options]);

  useEffect(() => {
    handleBase64Analysis();
  }, [handleBase64Analysis]);

  return bgColor;
}
